/*global localforage  */
let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let TabSet = require("../../widgets/TabSet");
let esUtils = require("ES/utils/esUtils");
let EditMasterList = require("./EditMasterList");
let NewActionListModal = require("./NewActionListModal");

module.exports = dd.createClass({
  getInitialState: function () {
    return {list_editing: 0, show_new_list_modal: false};
  },
  __clickListTab: function (id) {
    let self = this;
    return esUtils.wrapPreventDefault(function () {
      localforage.setItem('actionlist_edit_id', id); //will restore to this list after reload
      self.setState({list_editing: id});
    });
  },
  componentDidMount(props) {
    //with the data fully available now, try to restore the last-used action list
    let self = this;
    localforage.getItem('actionlist_edit_id', function (err, value) {
      if (_.isNull(err) && !_.isNull(value)) {
        self.setState({list_editing: value});
      }
    });
  },
  __toggleNewListModal: esUtils.wrapPreventDefault(function () {
    this.setState({show_new_list_modal: !this.state.show_new_list_modal});
  }),
  render: function () {
    let {speaker} = this.props;
    let {list_editing, show_new_list_modal} = this.state;

    let tabs = {};
    let clickListTab = this.__clickListTab;
    _.each(speaker.todolists, function (list) {
      tabs[list.id] = {
        onClick: clickListTab(list.id),
        name: list.listname
      };
    });
    tabs['static'] = {
      name: dd.div(null,
        dd.div({className: 'text-muted'},
          'Use different lists for different types of events (ie, "Keynote", "Full-day Workshop", etc.)'
        ),
        dd.button({className: 'btn btn-default', onClick: this.__toggleNewListModal}, 'New List')
      )
    };

    return dd.div({},
      TabSet({
        tabs: tabs,
        selected_tab: list_editing + '',//hack to fix it not === b/c it's comparing string and num
        lefty: true,
        tabs_width: 350,
        tab_body: EditMasterList({
          list_id: list_editing,
          speaker: speaker
        })
      }),
      show_new_list_modal
        ? NewActionListModal({
          speaker: speaker,
          onClose: this.__toggleNewListModal
        })
        : null
    );
  }
});



// WEBPACK FOOTER //
// ./src/components/account_settings/action_lists/MasterActionLists.js